module.exports = __webpack_public_path__ + "static/media/timeline-2010.a3e3c213.png";